import { FC, lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import { LazyComponent } from '../features/lazy-component'

const Competition = lazy(
  () => import('../__legacy__/components/platform/competition-page/CompetitionPage')
)

const CompetitionPage: FC = () => (
  <LazyComponent>
    <Competition />
  </LazyComponent>
)

export const CompetitionRoute: RouteObject = {
  path: '/competition',
  element: <CompetitionPage />
}
